import React from 'react'
import {Link} from 'react-router-dom'

import './Topbar.scss'
import SettingsMenu from '@components/SettingsMenu/SettingsMenu'
import BrandLogo from '@components/BrandLogo/BrandLogo'

export default () => (
	<div className="Topbar">
		<div className="brandWrap">
			<Link className="BrandLink" to="/dashboard">
				<BrandLogo size="tiny" logoKey="noText" />
			</Link>
		</div>
		<SettingsMenu />
	</div>
)


// WEBPACK FOOTER //
// ./src/components/Topbar/Topbar.jsx